import React from 'react'
import { Button, Form } from 'react-bootstrap'
import ReactQuill from 'react-quill'
import { CHAR_LIMITS, QUILL_FORMATS, TABS } from './constants'

const AppAnnouncementMessage = ({
  userState,
  userQuillRef,
  userQuillModules,
  handleUserMessageChange,
  handleUserFieldChange,
  setUserState,
  getPlainTextLength,
  pasteError,
  defaultBgColor = '#686464',
}) => {
  return (
    <div className='announcement-editor-section'>
      <Form.Label className='mb-1 fw-semibold'>Message</Form.Label>
      <ReactQuill
        ref={userQuillRef}
        theme='snow'
        value={userState.message}
        onChange={handleUserMessageChange}
        modules={userQuillModules}
        formats={QUILL_FORMATS}
        placeholder='Type your announcement message here...'
      />
      <div className='announcement-char-counter'>
        <span className={getPlainTextLength(userState.message) === CHAR_LIMITS[TABS.USER] ? 'text-danger fw-semibold' : 'text-muted'}>
          {getPlainTextLength(userState.message)} / {CHAR_LIMITS[TABS.USER]} characters used
        </span>
        {getPlainTextLength(userState.message) === CHAR_LIMITS[TABS.USER] ? (
          <span className='announcement-char-warning text-danger'>
            Maximum character limit reached. No more text can be added.
          </span>
        ) : pasteError && (
          <span className='announcement-char-warning text-danger'>
            {pasteError}
          </span>
        )}
      </div>
      <div className='announcement-options mt-4'>
        <Form.Group className='mb-3'>
          <Form.Check
            type='switch'
            id='dismissable-switch'
            label='Dismissable (show close button)'
            checked={userState.dismissable}
            onChange={handleUserFieldChange('dismissable')}
          />
        </Form.Group>
        <div className='announcement-color-row'>
          <Form.Group className='announcement-color-group'>
            <Form.Label className='mb-1'>
              Close Button Color
              <span
                className='text-muted ms-1'
                style={{ fontSize: '12px' }}
              >
                (optional, default: orange)
              </span>
            </Form.Label>
            <div className='d-flex align-items-center gap-2'>
              <Form.Control
                type='color'
                value={userState.closeBtnColor || '#ffc107'}
                onChange={handleUserFieldChange('closeBtnColor')}
                style={{ width: '50px', height: '38px', padding: '2px' }}
              />
              <Form.Control
                type='text'
                placeholder='e.g. #ffc107'
                value={userState.closeBtnColor}
                onChange={handleUserFieldChange('closeBtnColor')}
                style={{ maxWidth: '160px' }}
              />
              {userState.closeBtnColor && (
                <Button
                  variant='link'
                  size='sm'
                  className='p-0 text-danger'
                  onClick={() => setUserState(prev => ({ ...prev, closeBtnColor: '' }))}
                >
                  Clear
                </Button>
              )}
            </div>
          </Form.Group>
          <Form.Group className='announcement-color-group'>
            <Form.Label className='mb-1'>
              Background Color
              <span
                className='text-muted ms-1'
                style={{ fontSize: '12px' }}
              >
                (optional, default: gradient)
              </span>
            </Form.Label>
            <div className='d-flex align-items-center gap-2'>
              <Form.Control
                type='color'
                value={userState.bgColor || defaultBgColor}
                onChange={handleUserFieldChange('bgColor')}
                style={{ width: '50px', height: '38px', padding: '2px' }}
              />
              <Form.Control
                type='text'
                placeholder={`e.g. ${defaultBgColor}`}
                value={userState.bgColor}
                onChange={handleUserFieldChange('bgColor')}
                style={{ maxWidth: '160px' }}
              />
              {userState.bgColor && (
                <Button
                  variant='link'
                  size='sm'
                  className='p-0 text-danger'
                  onClick={() => setUserState(prev => ({ ...prev, bgColor: '' }))}
                >
                  Clear
                </Button>
              )}
            </div>
          </Form.Group>
        </div>
      </div>
    </div>
  )
}

export default AppAnnouncementMessage
